import React from "react";
import { IconCalendar, IconGrid, IconList } from "../shared/icons/IconLib";

const ICON_BY_MODE = {
  calendar: IconCalendar,
  table: IconList,
  card: IconGrid,
};

const LABEL_BY_MODE = {
  calendar: "Calendar",
  table: "Table",
  card: "Card",
};

export default function ViewModeIconToggle({
  value,
  onChange,
  modes = ["table", "card"],
  ariaLabel = "View mode",
}) {
  const safeModes = (Array.isArray(modes) ? modes : []).filter((m) => ICON_BY_MODE[m]);
  if (safeModes.length <= 1) return null;

  return (
    <div role="tablist" aria-label={ariaLabel} className="toolbar-view-mode-toggle">
      {safeModes.map((m) => {
        const active = m === value;
        const IconCmp = ICON_BY_MODE[m];
        const label = LABEL_BY_MODE[m] || m;
        return (
          <button
            key={m}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(m)}
            title={label}
            className={
              active
                ? "toolbar-view-mode-toggle__btn toolbar-view-mode-toggle__btn--active"
                : "toolbar-view-mode-toggle__btn"
            }
          >
            <IconCmp size={18} />
          </button>
        );
      })}
    </div>
  );
}
